
import { get } from 'lodash';
import { useSelector } from 'react-redux';
import s from '../../SecondaryCard.module.css';

function ScorecardExecutiveSummary() {
    const { executiveSummary } = useSelector((state) => {
        const scorecard = get(state, 'scoreCard', null);
        return {
            executiveSummary: scorecard.executiveSummary
        };
    });

    return (
        <div className={s.detailsContent}>
            <div className={s.executiveSummary}>
                {executiveSummary.summary}
            </div>
        </div>

    )
}

export default ScorecardExecutiveSummary;